<template>
  <div class="pad-info">
    <div class="pad-info__amenities">
      <refundability :cancellation="cancellation" />
      <div
        class="pad-info__amenity"
        v-for="(amenity, amenity_index) in rate_amenities"
        :key="_uid+'_amenity_'+amenity_index"
      >
        <amenity
          v-if="false"
          :item="amenity"
          :type="'rates'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Refundability from '@bookingv3/components/atoms/refundability'
import Amenity from "@bookingv3/components/atoms/amenity"

export default {
  name: 'pad-info',

  components: {
    'refundability': Refundability,
    'amenity': Amenity,
  },

  props: {
    rate_amenities: Array,
    cancellation: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .pad-info {
    color: $gray-600;
    font-size: $font-size-md;

    &__amenities {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &__refundable {
      margin-right: $grid-gutter-width / 3;
      margin-bottom: $grid-gutter-width / 6;
    }

    &__amenity {
      margin-right: $grid-gutter-width / 4;
      margin-bottom: $grid-gutter-width / 6;

      &:last-child {
        margin-right: 0;
      }
    }

    &__details {
      display: none;

      @include media-breakpoint-up(md){
        display: block;
      }
    }
  }

</style>